import { dataConfigType } from './data-config';
/*
  1609660800 (2021-01-03 08:00:00)
  1610265600 (2021-01-10 08:00:00)
  1610870400 (2021-01-17 08:00:00)
  1611475200 (2021-01-24 08:00:00)
  1612080000 (2021-01-31 08:00:00)
  1612684800 (2021-02-07 08:00:00)
  1613289600 (2021-02-14 08:00:00)
  1613894400 (2021-02-21 08:00:00)
  1614499200 (2021-02-28 08:00:00)
  1615104000 (2021-03-07 08:00:00)
  1615708800 (2021-03-14 08:00:00)
  1616313600 (2021-03-21 08:00:00)
  1616918400 (2021-03-28 08:00:00)
*/

export const testdataRange1 = { START: 1609488000, END: 1617174000 };
export const testdataRange2 = { START: 1609488000, END: 1617174000 };

const testdata1 = {
  start_date: testdataRange1.START,
  end_date: testdataRange1.END,
  okrs: [{
    id: null,
    series: {
      data: [{
        x: 1609660800000,
        y: 0
      }, {
        x: 1610265600000,
        y: 6
      }, {
        x: 1610870400000,
        y: 14
      }, {
        x: 1611475200000,
        y: 19
      }, {
        x: 1612080000000,
        y: 20
      }, {
        x: 1612684800000,
        y: 22
      }, {
        x: 1613289600000,
        y: 24
      // }, {
      //   x: 1613894400000,
      //   y: 23
      // }, {
      //   x: 1614499200000,
      //   y: 26
      }]
    }
  },
  {
    id: null, // getDataSetId(),
    series: {
      data: [{
        x: 1609660800000,
        y: 0
      }, {
        x: 1610265600000,
        y: 3
      }, {
        x: 1610870400000,
        y: 5
      }, {
        x: 1611475200000,
        y: 7
      }, {
        x: 1612080000000,
        y: 6
      }, {
        x: 1612684800000,
        y: 7
      }, {
        x: 1613289600000,
        y: 8
      // }, {
      //   x: 1613894400000,
      //   y: 11
      // }, {
      //   x: 1614499200000,
      //   y: 10
      }]
    }
  }],
};

const testdata2 = {
  start_date: testdataRange2.START,
  end_date: testdataRange2.END,
  okrs: [{
    id: null,
    series: {
      data: [{
        x: 1609660800000,
        y: 0
      }, {
        x: 1610265600000,
        y: 6
      }, {
        x: 1610870400000,
        y: 14
      }, {
        x: 1611475200000,
        y: 19
      }, {
        x: 1612080000000,
        y: 20
      }, {
        x: 1612684800000,
        y: 22
      }, {
        x: 1613289600000,
        y: 24
      }, {
        x: 1613894400000,
        y: 23
      }, {
        x: 1614499200000,
        y: 26
      }, {
        x: 1615104000000,
        y: 29
      }, {
        x: 1615708800000,
        y: 30
      }, {
        x: 1616313600000,
        y: 28
      }, {
        x: 1616918400000,
        y: 30
      }]
    }
  },{
    id: null,
    series: {
      data: [{
        x: 1609660800000,
        y: 0
      }, {
        x: 1610265600000,
        y: 3
      }, {
        x: 1610870400000,
        y: 5
      }, {
        x: 1611475200000,
        y: 7
      }, {
        x: 1612080000000,
        y: 6
      }, {
        x: 1612684800000,
        y: 7
      }, {
        x: 1613289600000,
        y: 8
      }, {
        x: 1613894400000,
        y: 11
      }, {
        x: 1614499200000,
        y: 10
      }, {
        x: 1615104000000,
        y: 11
      }, {
        x: 1615708800000,
        y: 13
      }, {
        x: 1616313600000,
        y: 15
      }, {
        x: 1616918400000,
        y: 18
      }]
    }
  }],
};

export const getTestData = (dataType) => {
  switch (dataType) {
    case dataConfigType.TESTDATA1:
      return testdata1;
    case dataConfigType.TESTDATA2:
      return testdata2;
    default:
      return {};  
  }
};
